export default __webpack_public_path__ + "static/proximity-do-f313cba5c2df405349a1e53b041c16ed.png";